import { Directive, input, TemplateRef } from "@angular/core";
import { Merge } from "../pojo/Util";

@Directive({
    selector: "ng-template[template]",
    standalone: true,
})
export class TypedTemplateDirective<TContext extends object> {
    readonly template = input.required<TemplateRef<TContext>>();

    static ngTemplateContextGuard<TContext extends object>(
        _dir: TypedTemplateDirective<TContext>,
        ctx: unknown,
    ): ctx is Merge<Record<PropertyKey, never>, TContext> {
        return true;
    }
}

@Directive({
    selector: "ng-template[templateContext]",
    standalone: true,
})
export class TypedTemplateContextDirective<TContext extends object> {
    readonly templateContext = input.required<TContext>();

    static ngTemplateContextGuard<TContext extends object>(
        _dir: TypedTemplateContextDirective<TContext>,
        ctx: unknown,
    ): ctx is Merge<Record<PropertyKey, never>, TContext> {
        return true;
    }
}

@Directive({
    selector: "ng-template[void]",
    standalone: true,
})
export class VoidTemplateDirective {
    static ngTemplateContextGuard(
        _dir: VoidTemplateDirective,
        ctx: unknown,
    ): ctx is Merge<Record<PropertyKey, never>, void> {
        return true;
    }
}
